import { render, staticRenderFns } from "./OpenstaandView.vue?vue&type=template&id=c44587b6"
import script from "./OpenstaandView.vue?vue&type=script&lang=js"
export * from "./OpenstaandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports